import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
class Deblais extends Component{

    render(){
        
        /* service tab menu */
        let serviceTabMenuData = [
            {iconName: '', tabMenuName: 'Déblais routiers'},
            {iconName: '', tabMenuName: 'Déblais sableux routiers'},
            {iconName: '', tabMenuName: 'Déblais bétons'},
            {iconName: '', tabMenuName: 'Déblais bétons ferraillés'},
            {iconName: '', tabMenuName: 'Déblais briques'},
            {iconName: '', tabMenuName: 'Déblais inertes classe III'},
        ];

        let serviceTabMenuDatalist = serviceTabMenuData.map((val, i)=>{
            return(
                <Tab key={i}>  <span className="icon"><i className={val.iconName} /></span> <span className="text">{val.tabMenuName}</span></Tab>
            )
        });

        
        /* service tab content */
        
        let serviceTabContentData = [
            {bgUrl: "routiers.jpg", contentTitle: 'Déblais routiers', contentDesc: 'Mélange de déblais voiries (bordures - enrobés - ternaire) sans fines.', serviceLink: 'service-details-left-sidebar'},
            {bgUrl: "sableroutier.jpg", contentTitle: 'Déblais sableux routiers', contentDesc: ' Mélange de déblais voiries (bordures - enrobés - ternaire) avec maximum 25% de fines sableuses', serviceLink: 'service-details-left-sidebar'},
            {bgUrl: "betons2.jpg", contentTitle: 'Déblais bétons', contentDesc: 'Bétons issus de dalle - de démolition de bâtiments ', serviceLink: 'service-details-left-sidebar'},
            {bgUrl: "betons.jpg", contentTitle: 'Déblais bétons ferraillés', contentDesc: 'Bétons issus de dalle - de démolition de bâtiments ferraillés', serviceLink: 'service-details-left-sidebar'},
            {bgUrl: "briques.jpg", contentTitle: 'Déblais briques', contentDesc: 'Briques de démolition de batîments', serviceLink: 'service-details-left-sidebar'},
            {bgUrl: "inertes.png", contentTitle: 'Déblais inertes classe III et sableux (>25% fines)', contentDesc: 'Mélanges terre - cailloux sans substances dangereuses', serviceLink: 'service-details-left-sidebar'}
        ];

        let serviceTabContentDatalist = serviceTabContentData.map((val, i)=>{
            return(
                <TabPanel key={i}>
                    <div className="service-tab__single-content-wrapper" style={{ backgroundImage: `url(assets/img/deblais/${val.bgUrl})` }}>
                        <div className="service-tab__single-content">
                            <h3 className="service-tab__title">{val.contentTitle}</h3>
                            <p className="service-tab__text">{val.contentDesc}</p>
                            {/* <a href={`${process.env.PUBLIC_URL}/${val.serviceLink}`} className="see-more-link">SEE MORE</a> */}
                        </div>
                    </div>
                </TabPanel>
            )
        });

        return(
            <div>

                {/*====================  service tab area ====================*/}
                <div className="service-tab-area section-space--inner--60">
                <div className="container">
                    <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title-area text-center">
                        <h2 className="section-title section-space--bottom--50">Déblais</h2>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        {/* service tab wrapper */}
                        
                        <div className="service-tab-wrapper">
                        <Tabs>
                            <div className="row no-gutters">
                                <div className="col-md-4">
                                    <TabList>
                                        <div className="service-tab__link-wrapper">
                                            {serviceTabMenuDatalist}
                                        </div>
                                    </TabList>
                                </div>

                                <div className="col-md-8">
                                    {serviceTabContentDatalist}
                                </div>
                            </div>
                        </Tabs>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                {/*====================  End of service tab area  ====================*/}
            </div>
        )
    }
}

export default Deblais;